import { ReactNode } from 'react'

import { TextLabel } from './styles'

interface ILabelProps {
  children: ReactNode
}

export function Label({ children }: ILabelProps) {
  return <TextLabel>{children}</TextLabel>
}
